import { Component, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon';
import { FileSizePipe } from './file-size.pipe';

@Component({
  selector: 'wma-file-item',
  standalone: true,
  host: {
    class: 'block',
  },
  templateUrl: './file-item.component.html',
  imports: [IconComponent, FileSizePipe],
})
export class FileItemComponent {
  readonly icon = input('');
  readonly size = input.required<number>();
  readonly name = input.required<string>();

  readonly clear = output();

  clearFile() {
    this.clear.emit();
  }
}
